(ns minorodata.analytics-models.events
  (:require
   [re-frame.core :as re-frame]
   [minorodata.analytics-models.api]))

(re-frame/reg-event-fx
 :analytics-models.events/init
 (fn []
   {:dispatch-n [[:analytics-models.api/fetch-model-registry]
                 [:analytics-models.api/fetch-models]
                 [:analytics-models.api/fetch-statuses]]}))
